import gsap from 'gsap';

export function homeHeadlinesAnimation(importantWords = ["Context","Curiosity","Discipline","Structure","Alignment"]) {
    const sectionAnchors = document.querySelectorAll('#home-headinesection section-anchor');
    if (!sectionAnchors.length) return;

    const normalSections = Array.from(sectionAnchors).slice(0, -2);
    const lastSection = sectionAnchors[sectionAnchors.length - 2];
    const footnote = sectionAnchors[sectionAnchors.length - 1];

    // Utility: wrap heading content in spans
    function wrapHeadingText(headingEl, importantWord) {
        const text = headingEl.textContent;
        const parts = text.split(new RegExp(`(${importantWord})`, 'gi'));

        headingEl.innerHTML = parts.map(part => {
            const isImportant = part.toLowerCase() === importantWord.toLowerCase();
            const spanClass = isImportant ? 'importantword' : '';
            return `<span class="${spanClass}">${part}</span>`;
        }).join('');
    }

    // Wrap headings and prepare initial styles
    normalSections.forEach((section, index) => {
        const heading = section.querySelector('h2, h3');
        const importantWord = importantWords[index] || '';

        if (heading && importantWord) {
            wrapHeadingText(heading, importantWord);

            const spans = heading.querySelectorAll('span');
            spans.forEach(span => {
                span.style.opacity = '0'; // start hidden
                if (span.classList.contains('importantword')) {
                    span.style.color = 'var(--eld-blue)';
                } else {
                    span.style.color = 'black';
                }
            });

            section.style.opacity = '0'; // section starts hidden too
        }
    });

    const tl = gsap.timeline({ delay: 0.5 });
    const staggerTime = 2.5;

    normalSections.forEach((section, index) => {
        const heading = section.querySelector('h2, h3');
        const baseTime = index * staggerTime;
        
        if (!heading) return;
        
        const importantSpan = heading.querySelector('.importantword');
        const allSpans = heading.querySelectorAll('span');
        
        tl.to(section, {
            opacity: 1,
            duration: 1,
            ease: 'power2.out'
        }, baseTime);
        
        tl.to(allSpans, {
            opacity: 1,
            duration: 1,
            stagger: 0.0
        }, baseTime + 0);
        
        // After 2 seconds: fade all out and move a clone
        if (importantSpan) {
            // Clone and style

            
            const clone = importantSpan.cloneNode(true);
            clone.style.position = 'absolute';
            clone.style.left = `${importantSpan.offsetLeft}px`;


            const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const baseFontSize = 3.5 * rootFontSize;
            const BASE_FUDGE = 7;
            const fudgeRatio = BASE_FUDGE / baseFontSize;

            const computed = getComputedStyle(importantSpan);
            const actualFontSize = parseFloat(computed.fontSize);
            const fudgeOffset = actualFontSize * fudgeRatio;


            clone.style.top = `${importantSpan.offsetTop+fudgeOffset}px`;
            clone.style.width = `${importantSpan.offsetWidth}px`;
            clone.style.height = `${importantSpan.offsetHeight}px`;
            clone.style.font = window.getComputedStyle(importantSpan).font;
            clone.style.lineHeight = window.getComputedStyle(importantSpan).lineHeight;
            clone.style.color = 'black';
            clone.style.opacity = '0';
            clone.style.pointerEvents = 'none';
            clone.style.zIndex = '9';
        
            heading.appendChild(clone); // add to DOM
            

            /*
            const clone = importantSpan.cloneNode(true);
            const originalRect = importantSpan.getBoundingClientRect();

            // Ensure the parent container is positioned (relative or absolute)
            const parent = importantSpan.offsetParent;
            const parentRect = parent.getBoundingClientRect();

            // Position clone relative to parent
            clone.style.position = 'absolute';
            clone.style.left = `${originalRect.left - parentRect.left}px`;
            clone.style.top = `${originalRect.top - parentRect.top}px`;
            clone.style.width = `${originalRect.width}px`;
            clone.style.height = `${originalRect.height}px`;

            const computed = window.getComputedStyle(importantSpan);
            clone.style.font = computed.font;
            clone.style.lineHeight = computed.lineHeight;
            clone.style.color = 'black';
            clone.style.opacity = '0';
            clone.style.pointerEvents = 'none';
            clone.style.zIndex = '9';
            clone.style.verticalAlign = window.getComputedStyle(importantSpan).verticalAlign;

            parent.appendChild(clone);
            */
            
        
            // Fade out all original spans
            tl.to(allSpans, {
                opacity: 0,
                duration: 0.6,
                ease: 'power2.inOut'
            }, baseTime + 1);
        
            // Fade in the clone (start over original word), then move it left
            tl.to(clone, {
                opacity: 1,
                duration: 0.6
            }, baseTime + 1);
        
            tl.to(clone, {
                x: -importantSpan.offsetLeft, // move to start of line
                duration: 1.3,
                ease: 'power2.inOut'
            }, baseTime + 1.8);
        }
        
    });
    //testing

    const totalRevealTime = normalSections.length * staggerTime;
    tl.to({}, { duration: 2 }, (totalRevealTime/2)+2);

    // Fade out normal sections
    tl.to(normalSections, {
        opacity: 0,
        duration: 1,
        ease: 'power2.inOut',
    });

    // Fade in last section
    tl.to(lastSection, {
        opacity: 1,
        duration: 1.5,
        ease: 'power2.out',
    });

    tl.to(footnote, {
        opacity: 1,
        duration: 1.5,
        ease: 'power2.out',
      }, '<');
}
